import { DbListBase } from "./db-list-base";
import { DbObjectBase } from "./db-object-base";
import { ICollectionReference } from '../database-cast/IDatabase';
import { Customer, System } from '../../../core/_shared/models/Customer';
import { DbCustomer } from './db-customer';



export class DbCustomers extends DbListBase<Customer> {


  constructor(collection: ICollectionReference) {
    super(collection);

  }

  public getCustomer(id: string): DbCustomer {
    return new DbCustomer(id, this._collection);
  }
}




